import { createAction, props, select } from '@ngrx/store';
import { Invoice } from '../../models/Invoice';

export const getInvoices = createAction('[Invoice] Get Invoices',
  props<{ customerNo: number }>()
);
export const getInvoicesSuccess = createAction(
  '[Invoice] Get Invoices Success',
  props<{ invoices: Invoice[] }>()
);
export const getInvoicesFailure = createAction(
  '[Invoice] Get Invoices Failure'
);
export const selectInvoice = createAction(
  '[Invoice] Select Invoice',
  props<{ orderNo: string, customerNo: number }>()
);
export const selectInvoiceSuccess = createAction(
  '[Invoice] Select Invoice Success',
  props<{ invoice: Invoice }>()
);
export const selectInvoiceFailure = createAction(
  '[Invoice] Get Invoice Failure'
);

export const deselectInvoice = createAction('[Invoice] Deselect Invoice');
